import { Component, HostListener, signal } from '@angular/core';
import { AppInfo } from '../../global/environment';
import { Loader } from '../../global/loader';
import { BrowserSharedService } from '../../shared/services/browser-shared.service';
import { UserService } from '../../shared/services/user.service';
import { Breakpoints } from '../../shared/types/breakpoints';

@Component({
  selector: 'app-header',
  imports: [],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
})
export class HeaderComponent {
  @HostListener('window:resize', ['$event.target'])
  onResize(target: any) {
    if (!this.navigationOpen()) return;

    if (target.innerWidth > 1024) {
      this.navigationOpen.set(false);
    }
  }

  isMobile = signal(window.innerWidth < Breakpoints.sm);
  navigationOpen = signal(false);

  client = AppInfo.Environment.client.toLowerCase();
  showPoweredByLogo = AppInfo.Environment.showPoweredByLogo;

  logoutURL = `${AppInfo.Environment.myAccountURL}/logout`;
  navigationItems: Array<{
    label: string;
    url: string;
    target?: '_self' | '_blank';
  }> = [
    {
      label: 'Help and support',
      url: 'https://www.domesticandgeneral.com/help-and-support',
      target: '_blank',
    },
    {
      label: 'Dashboard',
      url: `${AppInfo.Environment.myAccountURL}/my-account/dashboard`,
    },
    {
      label: 'Your details',
      url: `${AppInfo.Environment.myAccountURL}/my-account/my-details`,
    },
    {
      label: 'Your preferences',
      url: `${AppInfo.Environment.myAccountURL}/my-account/my-preferences`,
    },
  ];

  constructor(
    private readonly user: UserService,
    readonly browserShared: BrowserSharedService
  ) {}

  logout() {
    Loader.showLoader();
    this.user.logout();
  }

  scrollToMainContent() {
    document.getElementById('main-content')?.focus();
  }
}
